import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="site-footer">
      <nav className="footer-nav" aria-label="Footer">
        <Link to="/cameras">All cameras</Link>
        <span aria-hidden="true">·</span>
        <Link to="/about">About</Link>
        <span aria-hidden="true">·</span>
        <Link to="/privacy">Privacy &amp; Cookies</Link>
        <span aria-hidden="true">·</span>
        <Link to="/gallery">Settings</Link>
        <span aria-hidden="true">·</span>
        <Link to="/builder">Recipe Builder</Link>
        <span aria-hidden="true">·</span>
        <Link to="/light-meter">Measuring the light</Link>
        <span aria-hidden="true">·</span>
        <Link to="/pricing">Unlock Scene Analysis</Link>
      </nav>
      <p className="footer-note">No accounts. No tracking. No data sold. See our Privacy &amp; Cookies page.</p>
    </footer>
  );
}
